import { applySpec, compose, indexBy, merge, pathOr, prop } from 'ramda'

import {
  ACTION_GET_SEGMENTS_FAILURE,
  ACTION_GET_SEGMENTS_REQUEST,
  ACTION_GET_SEGMENTS_SUCCESS,
  ACTION_RESET_SEGMENTS_QUERY,
  ACTION_SEGMENTS_NAVIGATE,
} from '@/app/module/segments/definitions'
import { createReducer } from '@/app/service/util'

import defaultState from './state'

const transformSegments = (state, value = { values: [] }) => {
  const indexedPage = indexBy(prop('id'), value.values || [])

  return compose(
    merge(state),
    applySpec({
      page: ({ page }) => parseInt(page, 10),
      size: ({ size }) => parseInt(size, 10),
      total: ({ total }) => parseInt(total, 10),
      values: () => ({
        ...state.values,
        ...indexedPage,
      }),
      pages: ({ page }) => ({
        ...state.pages,
        [page]: value.values.map(({ id }) => id),
      }),
    }),
  )(value)
}

export default createReducer(defaultState, {
  [ACTION_GET_SEGMENTS_REQUEST]: (state) => ({
    ...state,
    list: {
      ...state.list,
      loading: true,
    },
  }),
  [ACTION_GET_SEGMENTS_SUCCESS]: (state, { value }) => ({
    ...state,
    list: {
      ...state.list,
      loading: false,
      data: transformSegments(state.list.data, value),
    },
  }),
  [ACTION_GET_SEGMENTS_FAILURE]: (state, { value }) => ({
    ...state,
    list: {
      ...state.list,
      loading: false,
      error: value,
    },
  }),
  [ACTION_RESET_SEGMENTS_QUERY]: (state) => {
    const values = pathOr({}, ['list', 'data', 'values'], state)
    const keys = Object.keys(values)
    const pages = {
      1: keys,
    }
    return {
      ...state,
      list: {
        loading: false,
        error: {},
        data: {
          values,
          page: 1,
          pages,
          size: 1000,
          total: keys.length,
        },
      },
    }
  },

  // NAVIGATE
  [ACTION_SEGMENTS_NAVIGATE]: (state, { value }) => ({
    ...state,
    list: {
      ...state.list,
      data: {
        ...state.list.data,
        page: value.page,
        search: value.searchTerm,
      },
    },
  }),
})
